import { Box, Typography } from '@mui/material'
import React from 'react'
import { AboutMe, CareerPath } from '../components'
import Skills from '../components/Skills'
import { learning, skills } from '../utils/constants'

const About = () => {
  return (
    <div >
      <AboutMe />
      <Box textAlign={'center'}>
        <Typography pl={5} display={'inline'} variant='h4' color={'#70FF00'} textAlign={'center'}>skills</Typography>
        <Typography display={'inline'} variant='h4' color={'#E0E0E0'} textAlign={'center'}>( )</Typography>
      </Box>
      <Box marginX={'auto'}>
      <Skills type={"USING NOW"} items={skills} />
      <Skills type={"LEARNING NOW"} items={learning} />
      </Box>
      <CareerPath />
    </div>
  )
}

export default About